import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material';

export const UserPlusIcon = (props: SvgIconProps) => (
  <SvgIcon
    viewBox="0 0 26 26"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    sx={{ fill: 'none' }}
    {...props}
  >
    <path
      d="M17.3359 22.75V20.5833C17.3359 19.4341 16.8794 18.3319 16.0667 17.5192C15.2541 16.7065 14.1519 16.25 13.0026 16.25H5.41927C4.27 16.25 3.1678 16.7065 2.35514 17.5192C1.54248 18.3319 1.08594 19.4341 1.08594 20.5833V22.75"
    />

    <path
      d="M9.20833 11.9167C11.6016 11.9167 13.5417 9.97657 13.5417 7.58333C13.5417 5.1901 11.6016 3.25 9.20833 3.25C6.8151 3.25 4.875 5.1901 4.875 7.58333C4.875 9.97657 6.8151 11.9167 9.20833 11.9167Z"
    />

    <path
      d="M21.6641 8.66675V15.1667"
    />

    <path
      d="M24.9141 11.9167H18.4141"
    />
  </SvgIcon>
);
